import { render, staticRenderFns } from "./question-list.vue?vue&type=template&id=7226a7a0&"
import script from "./question-list.vue?vue&type=script&lang=ts&"
export * from "./question-list.vue?vue&type=script&lang=ts&"
import style0 from "./question-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports